<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

interface SkeletonProps {
  class?: HTMLAttributes['class'];
}

const props = defineProps<SkeletonProps>();
</script>

<template>
  <div
    :class="
      cn(
        'tw-animate-pulse tw-rounded-md tw-bg-neutral-900/10 dark:tw-bg-neutral-50/10',
        props.class
      )
    "
  />
</template>
